module.exports = __webpack_public_path__ + "img/Flunder_14.27da0ed4.jpg";